import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import myImg from "../../Assets/developer_circle.png";
import Tilt from "react-parallax-tilt";
import {
  AiFillGithub,
  AiOutlineTwitter,
  AiFillInstagram,
} from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";

function Home2() {
  return (
    <Container fluid className="home-about-section" id="about">
      <Container>
        <Row>
          <Col md={8} className="home-about-description">
            <h1 style={{ fontSize: "2.6em" }}>
              LET ME <span className="purple"> INTRODUCE </span> MYSELF
            </h1>
            <p className="home-about-body">
              Hello! I'm a software developer
              <br />who found my way into the captivating realm of

              <b className="purple">&nbsp;programming</b>

              <br />
              <br />
              while continually seeking out new

              <b className="purple">&nbsp;challenges </b> My expertise lies in {" "}
              <b className="purple"> Flutter & Dart programming
              </b>
              &nbsp;
              particularly focusing on mobile development to enrich user experiences.
              Just as I enjoy delving into the complexities of coding, I'm equally fascinated by the boundless opportunities presented by space technology and the creative allure of animation.

              <br />
              <br />
              Whenever possible, I also apply my passion for developing products
              with <b className="purple">&nbsp;Node.js</b> and

              <b className="purple">
                {" "}
                Modern Javascript Library and Frameworks
              </b>

              &nbsp; like

              <b className="purple">&nbsp; React.js and Next.js</b>

            </p>
          </Col>
          <Col md={4} className="myAvtar d-flex justify-content-center align-items-center">
            <Tilt>
              <img src={myImg} className="img-fluid" alt="avatar" />
            </Tilt>
          </Col>
        </Row>
        <Row>
          <Col md={12} className="home-about-social">
            <h1>FIND ME ON</h1>
            <p>
              Feel free to <span className="purple">connect </span>with me
            </p>
            <ul className="home-about-social-links">
              <li className="social-icons">
                <a
                  href="https://github.com/Sonal-1601"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <AiFillGithub />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://twitter.com/possiblysonal"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <AiOutlineTwitter />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://www.linkedin.com/in/pandeysonal/"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <FaLinkedinIn />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://instagram.com/possiblysonal"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour home-social-icons"
                >
                  <AiFillInstagram />
                </a>
              </li>
            </ul>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}
export default Home2;
